import { useQuery } from '@tanstack/react-query';

import { getAiSummaryStats } from '~/services/AiSummaryStatsService';

import { reportingQueryKeys } from './reportingQueryKeys';

export function useAiSummaryStats() {
  return useQuery({
    queryKey: reportingQueryKeys.aiSummaryStats(),
    queryFn: ({ signal }) => getAiSummaryStats(signal ? { signal } : undefined),
  });
}
